













































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'

@Component
export default class ComponentLiberarRepasses extends Vue {
  loadLiberarRepasses: boolean = false

  get modalLiberarRepasses() { return this.getFinanceiroStore.modal.liberarRepasses }
  set modalLiberarRepasses(value: boolean) { this.getFinanceiroStore.setModal({ name: 'liberarRepasses', value }) }

  get loadingLiberarRepasses() { return this.loadLiberarRepasses }
  set loadingLiberarRepasses(value: boolean) { this.loadLiberarRepasses = value }

  async liberarRepasses() {
    this.loadingLiberarRepasses = true
    const response: any = await this.getFinanceiroStore.liberarRepasses()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Repasses liberados com sucesso!', icon: 'done', color: '#2E7D32' })
      this.modalLiberarRepasses = false
      // FXSR-2699 — o usuário continua na geração: recarrega a lista no lugar (itens, ações e dados
      // gerais) em vez de fechar a geração e voltar para a listagem.
      await this.getFinanceiroStore.getGeracaoDeRepassesItemsVisualizar(this.getFinanceiroStore.idForLoadValidacaoEGeracaoRepasse)
      this.getFinanceiroStore.getGeracaoRepasseAll()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao liberar os repasses.', icon: 'warning', color: '#C62828' })
    }
    this.loadingLiberarRepasses = false
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }
}
